import enBookings from "./locales/en/bookings.json";
import enHome from "./locales/en/home.json";
import enClubs from "./locales/en/clubs.json";
import enCourts from "./locales/en/courts.json";
import enExceptions from "./locales/en/exceptions.json";
import enInputs from "./locales/en/inputs.json";
import enHistory from "./locales/en/history.json";
import enAuth from "./locales/en/auth.json";
import enLogin from "./locales/en/login.json";
import enRegister from "./locales/en/register.json";
import enForgot from "./locales/en/forgot.json";
import enGuestHeader from "./locales/en/guestHeader.json";
import enAccount from "./locales/en/account.json";
import enPasses from "./locales/en/passes.json";
import enPricing from "./locales/en/pricing.json";
import enAddress from "./locales/en/address.json";
import enCommon from "./locales/en/common.json";
import enFooter from "./locales/en/footer.json";
import enTerms from "./locales/en/terms.json";
import enLanguage from "./locales/en/language.json";
import enDashboard from './locales/en/dashboard.json'
import enNav from './locales/en/nav.json'
import enPartners from './locales/en/partners.json'
import enBlocks from './locales/en/blocks.json'
import enReports from './locales/en/reports.json'
import enUsers from './locales/en/users.json'
import enPayments from './locales/en/payments.json'
import enAudit from './locales/en/audit.json'
import enHelp from './locales/en/help.json'

import roBookings from "./locales/ro/bookings.json";
import roHome from "./locales/ro/home.json";
import roClubs from "./locales/ro/clubs.json";
import roCourts from "./locales/ro/courts.json";
import roExceptions from "./locales/ro/exceptions.json";
import roInputs from "./locales/ro/inputs.json";
import roHistory from "./locales/ro/history.json";
import roAuth from "./locales/ro/auth.json";
import roLogin from "./locales/ro/login.json";
import roRegister from "./locales/ro/register.json";
import roForgot from "./locales/ro/forgot.json";
import roGuestHeader from "./locales/ro/guestHeader.json";
import roAccount from "./locales/ro/account.json";
import roPasses from "./locales/ro/passes.json";
import roPricing from "./locales/ro/pricing.json";
import roAddress from "./locales/ro/address.json";
import roCommon from "./locales/ro/common.json";
import roFooter from "./locales/ro/footer.json";
import roTerms from "./locales/ro/terms.json";
import roLanguage from "./locales/ro/language.json";
import roDashboard from './locales/ro/dashboard.json'
import roNav from './locales/ro/nav.json'
import roPartners from './locales/ro/partners.json'
import roBlocks from './locales/ro/blocks.json'
import roReports from './locales/ro/reports.json'
import roUsers from './locales/ro/users.json'
import roPayments from './locales/ro/payments.json'
import roAudit from './locales/ro/audit.json'
import roHelp from './locales/ro/help.json'

export const resources = {
  en: {
    bookings: enBookings,
    home: enHome,
    clubs: enClubs,
    courts: enCourts,
    exceptions: enExceptions,
    inputs: enInputs,
    history: enHistory,
    auth: enAuth,
    login: enLogin,
    register: enRegister,
    forgot: enForgot,
    guestHeader: enGuestHeader,
    account: enAccount,
    passes: enPasses,
    pricing: enPricing,
    address: enAddress,
    common: enCommon,
    footer: enFooter,
    terms: enTerms,
    language: enLanguage,
    dashboard: enDashboard,
    nav: enNav,
    partners: enPartners,
    blocks: enBlocks,
    reports: enReports,
    users: enUsers,
    payments: enPayments,
    audit: enAudit,
    help: enHelp,
  },

  ro: {
    bookings: roBookings,
    home: roHome,
    clubs: roClubs,
    courts: roCourts,
    exceptions: roExceptions,
    inputs: roInputs,
    history: roHistory,
    auth: roAuth,
    login: roLogin,
    register: roRegister,
    forgot: roForgot,
    guestHeader: roGuestHeader,
    account: roAccount,
    passes: roPasses,
    pricing: roPricing,
    address: roAddress,
    common: roCommon,
    footer: roFooter,
    terms: roTerms,
    language: roLanguage,
    dashboard: roDashboard,
    nav: roNav,
    partners: roPartners,
    blocks: roBlocks,
    reports: roReports,
    users: roUsers,
    payments: roPayments,
    audit: roAudit,
    help: roHelp,
  },
};
